exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row--retail-name[data-v-cf12ce60],.row--secondary[data-v-cf12ce60]{margin-bottom:10px}.retail-name[data-v-cf12ce60]{font-weight:700;font-family:Open Sans,sans-serif;margin-bottom:20px}.retail-summary[data-v-cf12ce60]{margin-top:10px;font-family:Roboto Slab,serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cf12ce60","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/shared/components/catalog/RetouchingModal/RetouchingPackageSidebar.vue
// module id = 843
// module chunks = 0 2